import { Injectable } from "@angular/core";
import { RestService } from "../../core/rest.service";
import { NoteObjectType } from './noteobjecttype.enum';
import { UserNote } from "./usernote.model";
import { Observable } from "rxjs";

@Injectable()
export class UserNoteRest {
    constructor(private http: RestService) { }     
    
    public postNote(note: UserNote) {
        return this.http.post<UserNote>("api/usernote", note);
    }
    
    public getNote(noteObjectType: NoteObjectType, objectId: number) {
        return this.http.get<UserNote>(`api/usernote/${noteObjectType}/${objectId}`);
    }
}